/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as WholesalerSettingsRouteImport } from './app/routes/wholesaler-settings'
import { Route as TeamRouteImport } from './app/routes/team'
import { Route as SigninRouteImport } from './app/routes/signin'
import { Route as SetupRouteImport } from './app/routes/setup'
import { Route as SettingsRouteImport } from './app/routes/settings'
import { Route as ServicesRouteImport } from './app/routes/services'
import { Route as ReportsRouteImport } from './app/routes/reports'
import { Route as RecoverAccountRouteImport } from './app/routes/recover-account'
import { Route as PendingActivationRouteImport } from './app/routes/pending-activation'
import { Route as OverviewRouteImport } from './app/routes/overview'
import { Route as NumbersRouteImport } from './app/routes/numbers'
import { Route as BrandingRouteImport } from './app/routes/branding'
import { Route as BillingRouteImport } from './app/routes/billing'
import { Route as AdminSettingsRouteImport } from './app/routes/admin-settings'
import { Route as ActivateRouteImport } from './app/routes/activate'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as AdminSettingsRolesAdminRouteImport } from './app/routes/admin-settings.roles-admin'
import { Route as AdminSettingsPermissionsAdminRouteImport } from './app/routes/admin-settings.permissions-admin'
import { Route as AdminSettingsApiKeysAdminRouteImport } from './app/routes/admin-settings.api-keys-admin'
import { Route as AdminSettingsServiceAdminServiceIdRouteImport } from './app/routes/admin-settings.service-admin.$serviceId'
import { Route as AdminSettingsRolesAdminRoleIdRouteImport } from './app/routes/admin-settings.roles-admin.$roleId'
import { Route as AdminSettingsFeatureAdminFeatureIdRouteImport } from './app/routes/admin-settings.feature-admin.$featureId'

const WholesalerSettingsRoute = WholesalerSettingsRouteImport.update({
  id: '/wholesaler-settings',
  path: '/wholesaler-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverAccountRoute = RecoverAccountRouteImport.update({
  id: '/recover-account',
  path: '/recover-account',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingActivationRoute = PendingActivationRouteImport.update({
  id: '/pending-activation',
  path: '/pending-activation',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewRoute = OverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const NumbersRoute = NumbersRouteImport.update({
  id: '/numbers',
  path: '/numbers',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandingRoute = BrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin-settings',
  path: '/admin-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRolesAdminRoute = AdminSettingsRolesAdminRouteImport.update({
  id: '/roles-admin',
  path: '/roles-admin',
  getParentRoute: () => AdminSettingsRoute,
} as any)
const AdminSettingsPermissionsAdminRoute =
  AdminSettingsPermissionsAdminRouteImport.update({
    id: '/permissions-admin',
    path: '/permissions-admin',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsApiKeysAdminRoute =
  AdminSettingsApiKeysAdminRouteImport.update({
    id: '/api-keys-admin',
    path: '/api-keys-admin',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsServiceAdminServiceIdRoute =
  AdminSettingsServiceAdminServiceIdRouteImport.update({
    id: '/service-admin/$serviceId',
    path: '/service-admin/$serviceId',
    getParentRoute: () => AdminSettingsRoute,
  } as any)
const AdminSettingsRolesAdminRoleIdRoute =
  AdminSettingsRolesAdminRoleIdRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AdminSettingsRolesAdminRoute,
  } as any)
const AdminSettingsFeatureAdminFeatureIdRoute =
  AdminSettingsFeatureAdminFeatureIdRouteImport.update({
    id: '/feature-admin/$featureId',
    path: '/feature-admin/$featureId',
    getParentRoute: () => AdminSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin-settings': typeof AdminSettingsRouteWithChildren
  '/billing': typeof BillingRoute
  '/branding': typeof BrandingRoute
  '/numbers': typeof NumbersRoute
  '/overview': typeof OverviewRoute
  '/pending-activation': typeof PendingActivationRoute
  '/recover-account': typeof RecoverAccountRoute
  '/reports': typeof ReportsRoute
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/signin': typeof SigninRoute
  '/team': typeof TeamRoute
  '/wholesaler-settings': typeof WholesalerSettingsRoute
  '/admin-settings/api-keys-admin': typeof AdminSettingsApiKeysAdminRoute
  '/admin-settings/permissions-admin': typeof AdminSettingsPermissionsAdminRoute
  '/admin-settings/roles-admin': typeof AdminSettingsRolesAdminRouteWithChildren
  '/admin-settings/feature-admin/$featureId': typeof AdminSettingsFeatureAdminFeatureIdRoute
  '/admin-settings/roles-admin/$roleId': typeof AdminSettingsRolesAdminRoleIdRoute
  '/admin-settings/service-admin/$serviceId': typeof AdminSettingsServiceAdminServiceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin-settings': typeof AdminSettingsRouteWithChildren
  '/billing': typeof BillingRoute
  '/branding': typeof BrandingRoute
  '/numbers': typeof NumbersRoute
  '/overview': typeof OverviewRoute
  '/pending-activation': typeof PendingActivationRoute
  '/recover-account': typeof RecoverAccountRoute
  '/reports': typeof ReportsRoute
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/signin': typeof SigninRoute
  '/team': typeof TeamRoute
  '/wholesaler-settings': typeof WholesalerSettingsRoute
  '/admin-settings/api-keys-admin': typeof AdminSettingsApiKeysAdminRoute
  '/admin-settings/permissions-admin': typeof AdminSettingsPermissionsAdminRoute
  '/admin-settings/roles-admin': typeof AdminSettingsRolesAdminRouteWithChildren
  '/admin-settings/feature-admin/$featureId': typeof AdminSettingsFeatureAdminFeatureIdRoute
  '/admin-settings/roles-admin/$roleId': typeof AdminSettingsRolesAdminRoleIdRoute
  '/admin-settings/service-admin/$serviceId': typeof AdminSettingsServiceAdminServiceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin-settings': typeof AdminSettingsRouteWithChildren
  '/billing': typeof BillingRoute
  '/branding': typeof BrandingRoute
  '/numbers': typeof NumbersRoute
  '/overview': typeof OverviewRoute
  '/pending-activation': typeof PendingActivationRoute
  '/recover-account': typeof RecoverAccountRoute
  '/reports': typeof ReportsRoute
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/setup': typeof SetupRoute
  '/signin': typeof SigninRoute
  '/team': typeof TeamRoute
  '/wholesaler-settings': typeof WholesalerSettingsRoute
  '/admin-settings/api-keys-admin': typeof AdminSettingsApiKeysAdminRoute
  '/admin-settings/permissions-admin': typeof AdminSettingsPermissionsAdminRoute
  '/admin-settings/roles-admin': typeof AdminSettingsRolesAdminRouteWithChildren
  '/admin-settings/feature-admin/$featureId': typeof AdminSettingsFeatureAdminFeatureIdRoute
  '/admin-settings/roles-admin/$roleId': typeof AdminSettingsRolesAdminRoleIdRoute
  '/admin-settings/service-admin/$serviceId': typeof AdminSettingsServiceAdminServiceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/admin-settings'
    | '/billing'
    | '/branding'
    | '/numbers'
    | '/overview'
    | '/pending-activation'
    | '/recover-account'
    | '/reports'
    | '/services'
    | '/settings'
    | '/setup'
    | '/signin'
    | '/team'
    | '/wholesaler-settings'
    | '/admin-settings/api-keys-admin'
    | '/admin-settings/permissions-admin'
    | '/admin-settings/roles-admin'
    | '/admin-settings/feature-admin/$featureId'
    | '/admin-settings/roles-admin/$roleId'
    | '/admin-settings/service-admin/$serviceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/admin-settings'
    | '/billing'
    | '/branding'
    | '/numbers'
    | '/overview'
    | '/pending-activation'
    | '/recover-account'
    | '/reports'
    | '/services'
    | '/settings'
    | '/setup'
    | '/signin'
    | '/team'
    | '/wholesaler-settings'
    | '/admin-settings/api-keys-admin'
    | '/admin-settings/permissions-admin'
    | '/admin-settings/roles-admin'
    | '/admin-settings/feature-admin/$featureId'
    | '/admin-settings/roles-admin/$roleId'
    | '/admin-settings/service-admin/$serviceId'
  id:
    | '__root__'
    | '/'
    | '/activate'
    | '/admin-settings'
    | '/billing'
    | '/branding'
    | '/numbers'
    | '/overview'
    | '/pending-activation'
    | '/recover-account'
    | '/reports'
    | '/services'
    | '/settings'
    | '/setup'
    | '/signin'
    | '/team'
    | '/wholesaler-settings'
    | '/admin-settings/api-keys-admin'
    | '/admin-settings/permissions-admin'
    | '/admin-settings/roles-admin'
    | '/admin-settings/feature-admin/$featureId'
    | '/admin-settings/roles-admin/$roleId'
    | '/admin-settings/service-admin/$serviceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivateRoute: typeof ActivateRoute
  AdminSettingsRoute: typeof AdminSettingsRouteWithChildren
  BillingRoute: typeof BillingRoute
  BrandingRoute: typeof BrandingRoute
  NumbersRoute: typeof NumbersRoute
  OverviewRoute: typeof OverviewRoute
  PendingActivationRoute: typeof PendingActivationRoute
  RecoverAccountRoute: typeof RecoverAccountRoute
  ReportsRoute: typeof ReportsRoute
  ServicesRoute: typeof ServicesRoute
  SettingsRoute: typeof SettingsRoute
  SetupRoute: typeof SetupRoute
  SigninRoute: typeof SigninRoute
  TeamRoute: typeof TeamRoute
  WholesalerSettingsRoute: typeof WholesalerSettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wholesaler-settings': {
      id: '/wholesaler-settings'
      path: '/wholesaler-settings'
      fullPath: '/wholesaler-settings'
      preLoaderRoute: typeof WholesalerSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-account': {
      id: '/recover-account'
      path: '/recover-account'
      fullPath: '/recover-account'
      preLoaderRoute: typeof RecoverAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-activation': {
      id: '/pending-activation'
      path: '/pending-activation'
      fullPath: '/pending-activation'
      preLoaderRoute: typeof PendingActivationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview': {
      id: '/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof OverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/numbers': {
      id: '/numbers'
      path: '/numbers'
      fullPath: '/numbers'
      preLoaderRoute: typeof NumbersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/branding': {
      id: '/branding'
      path: '/branding'
      fullPath: '/branding'
      preLoaderRoute: typeof BrandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-settings': {
      id: '/admin-settings'
      path: '/admin-settings'
      fullPath: '/admin-settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-settings/roles-admin': {
      id: '/admin-settings/roles-admin'
      path: '/roles-admin'
      fullPath: '/admin-settings/roles-admin'
      preLoaderRoute: typeof AdminSettingsRolesAdminRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin-settings/permissions-admin': {
      id: '/admin-settings/permissions-admin'
      path: '/permissions-admin'
      fullPath: '/admin-settings/permissions-admin'
      preLoaderRoute: typeof AdminSettingsPermissionsAdminRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin-settings/api-keys-admin': {
      id: '/admin-settings/api-keys-admin'
      path: '/api-keys-admin'
      fullPath: '/admin-settings/api-keys-admin'
      preLoaderRoute: typeof AdminSettingsApiKeysAdminRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin-settings/service-admin/$serviceId': {
      id: '/admin-settings/service-admin/$serviceId'
      path: '/service-admin/$serviceId'
      fullPath: '/admin-settings/service-admin/$serviceId'
      preLoaderRoute: typeof AdminSettingsServiceAdminServiceIdRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
    '/admin-settings/roles-admin/$roleId': {
      id: '/admin-settings/roles-admin/$roleId'
      path: '/$roleId'
      fullPath: '/admin-settings/roles-admin/$roleId'
      preLoaderRoute: typeof AdminSettingsRolesAdminRoleIdRouteImport
      parentRoute: typeof AdminSettingsRolesAdminRoute
    }
    '/admin-settings/feature-admin/$featureId': {
      id: '/admin-settings/feature-admin/$featureId'
      path: '/feature-admin/$featureId'
      fullPath: '/admin-settings/feature-admin/$featureId'
      preLoaderRoute: typeof AdminSettingsFeatureAdminFeatureIdRouteImport
      parentRoute: typeof AdminSettingsRoute
    }
  }
}

interface AdminSettingsRolesAdminRouteChildren {
  AdminSettingsRolesAdminRoleIdRoute: typeof AdminSettingsRolesAdminRoleIdRoute
}

const AdminSettingsRolesAdminRouteChildren: AdminSettingsRolesAdminRouteChildren =
  {
    AdminSettingsRolesAdminRoleIdRoute: AdminSettingsRolesAdminRoleIdRoute,
  }

const AdminSettingsRolesAdminRouteWithChildren =
  AdminSettingsRolesAdminRoute._addFileChildren(
    AdminSettingsRolesAdminRouteChildren,
  )

interface AdminSettingsRouteChildren {
  AdminSettingsApiKeysAdminRoute: typeof AdminSettingsApiKeysAdminRoute
  AdminSettingsPermissionsAdminRoute: typeof AdminSettingsPermissionsAdminRoute
  AdminSettingsRolesAdminRoute: typeof AdminSettingsRolesAdminRouteWithChildren
  AdminSettingsFeatureAdminFeatureIdRoute: typeof AdminSettingsFeatureAdminFeatureIdRoute
  AdminSettingsServiceAdminServiceIdRoute: typeof AdminSettingsServiceAdminServiceIdRoute
}

const AdminSettingsRouteChildren: AdminSettingsRouteChildren = {
  AdminSettingsApiKeysAdminRoute: AdminSettingsApiKeysAdminRoute,
  AdminSettingsPermissionsAdminRoute: AdminSettingsPermissionsAdminRoute,
  AdminSettingsRolesAdminRoute: AdminSettingsRolesAdminRouteWithChildren,
  AdminSettingsFeatureAdminFeatureIdRoute:
    AdminSettingsFeatureAdminFeatureIdRoute,
  AdminSettingsServiceAdminServiceIdRoute:
    AdminSettingsServiceAdminServiceIdRoute,
}

const AdminSettingsRouteWithChildren = AdminSettingsRoute._addFileChildren(
  AdminSettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivateRoute: ActivateRoute,
  AdminSettingsRoute: AdminSettingsRouteWithChildren,
  BillingRoute: BillingRoute,
  BrandingRoute: BrandingRoute,
  NumbersRoute: NumbersRoute,
  OverviewRoute: OverviewRoute,
  PendingActivationRoute: PendingActivationRoute,
  RecoverAccountRoute: RecoverAccountRoute,
  ReportsRoute: ReportsRoute,
  ServicesRoute: ServicesRoute,
  SettingsRoute: SettingsRoute,
  SetupRoute: SetupRoute,
  SigninRoute: SigninRoute,
  TeamRoute: TeamRoute,
  WholesalerSettingsRoute: WholesalerSettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
